<template lang="html">
  <div class="">
      <div class="text-center">
        <br>
        <img src="/immagini/logo-login.png" style="height: 40px">
        <br>
      </div>
      <Content class="content-sm" style="width: 100%; max-width: 300px; margin: 2em auto; padding: 1em; min-height: auto; flex-grow: 0; text-align: center">
        <img src="/immagini/logo.png" style="height: 80px; margin: 20px 0">
        <h2>Login</h2>
        <br>
        <Alert v-if="alert" :type="alert.type" show-icon>
          {{ alert.txt }}
        </Alert>
        <Form @submit.native.prevent="login">
          <FormItem>
            <Input v-model="form.email" type="email" required placeholder="Email"/>
          </FormItem>
          <FormItem v-if="!resetting">
            <Input v-model="form.password" type="password" required placeholder="Password"/>
          </FormItem>
          <FormItem v-if="!resetting" style="text-align: center">
            <Button onclick="location.href='#';" href="#" html-type="submit" type="primary" :loading="loading">
              <Icon type="log-in"></Icon>
              Login
            </Button>
            <br>
            <a v-if="$store.config.NAME=='Edesoft' || $store.config.IS_LOCAL" href="#/demo">Attiva demo</a>
            <a v-if="$store.config.NAME=='Edesoft' || $store.config.IS_LOCAL">    |   </a>
            <a href="#" @click.prevent="alert=null; resetting=true">Password dimenticata?</a>
          </FormItem>
          <FormItem v-else>
            <Button html-type="submit" type="primary" :loading="loading">Invia email di recupero</Button>
            <br>
            <a href="#" @click.prevent="alert=null; resetting=false">Annulla</a>
          </FormItem>
        </Form>
      </Content>
  </div>
</template>

<script>
export default {
  data () {
    return {
      alert: null,
      login_failed: false,
      resetting: false,
      form: {},
      loading: false,
    }
  },

  mounted () {
    if (this.$store.config.IS_LOCAL) {
      this.$set(this.form, 'email', 'testmail123@grr.la')
    }
    console.log(this.$store.config.NAME)
  },

  methods: {
    login () {
      this.alert = null
      this.loading = true
      if(this.resetting){
        this.$http.post('.s/auth/recovery', this.form).then(
        res => {
          this.alert = {
            type: 'success',
            txt: 'La mail è stata inviata correttamente '
          }
          this.resetting = false
          this.form.password = ''
        },
        err => {
          console.log('error', err)
          this.alert = {
            type: 'error',
            txt: 'Email non trovata'
          }
        }
        ).finally(res => {this.loading = false})
      }
      else {
        this.loading = true
        this.$http.post('.s/auth/login', this.form).then(res => {
          var token = res.data.token
          this.$http.get('auth/me?token='+token).then(res => {
            this.$store.session = {
              token,
              user: res.data
            }
          })
        }, err => {
          console.log('error', err)
          this.alert = {
            type: 'error',
            txt: 'Login fallito'
          }
        }).finally(res => {this.loading = false})
      }
    }
  }
}
</script>

<style lang="css">
</style>
